import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import BlogCard from "@/components/BlogCard";

interface Article {
  title: string;
  excerpt: string;
  image: string;
  author: string;
  date: string;
  categories: string[];
  slug: string;
}

interface CategorySectionProps {
  title: string;
  description?: string;
  articles: Article[];
  viewAllLink: string;
  viewAllLabel?: string;
}

const CategorySection = ({ title, description, articles, viewAllLink, viewAllLabel = "View All" }: CategorySectionProps) => {
  if (articles.length === 0) return null;

  return (
    <section className="py-12">
      <div className="flex items-end justify-between mb-2">
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">{title}</h2>
          {description && (
            <p className="text-muted-foreground mt-2 max-w-xl">{description}</p>
          )}
        </div>
        <Link
          to={viewAllLink}
          className="hidden md:inline-flex items-center gap-1 text-accent text-sm font-medium hover:gap-2 transition-all whitespace-nowrap"
        >
          {viewAllLabel} <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      <div className="h-px bg-border mt-6 mb-8" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {articles.map((article) => (
          <BlogCard key={article.slug} {...article} />
        ))}
      </div>
      <Link
        to={viewAllLink}
        className="md:hidden inline-flex items-center gap-1 text-accent text-sm font-medium mt-6 hover:gap-2 transition-all"
      >
        {viewAllLabel} <ArrowRight className="w-4 h-4" />
      </Link>
    </section>
  );
};

export default CategorySection;
